<template>
  <section class="sa-dist">
    <div class="sa-dist__head">
      <h3 class="sa-dist__title">{{ title }}</h3>
      <p v-if="subtitle" class="sa-dist__subtitle">{{ subtitle }}</p>
    </div>

    <div class="sa-dist__group" v-for="(group, groupIndex) in groups" :key="group.title || groupIndex">
      <h4 v-if="group.title" class="sa-dist__group-title">{{ group.title }}</h4>
      <ul class="sa-dist__list" role="list">
        <li v-for="item in group.items" :key="item.label" class="sa-dist__item">
          <div class="sa-dist__row">
            <span class="sa-dist__label">
              <span class="sa-dist__swatch" :style="{ background: item.color }" aria-hidden="true"></span>
              {{ item.label }}
            </span>
            <span class="sa-dist__values">
              <strong>{{ formatNumberBR(item.value) }}</strong>
              <span class="sa-dist__pct">{{ formatPercent(item.value, group.total) }}</span>
            </span>
          </div>
          <div
            class="sa-dist__track"
            role="progressbar"
            :aria-valuenow="item.value"
            :aria-valuemin="0"
            :aria-valuemax="group.total"
            :aria-label="`${item.label}: ${item.value}`"
          >
            <div
              class="sa-dist__fill"
              :style="{
                width: percentWidth(item.value, group.total),
                background: item.color,
              }"
            ></div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { formatNumberBR } from '@/utils/superAdmin/formatters';

export default {
  name: 'DashboardDistribution',
  props: {
    title: { type: String, default: 'Distribuição das empresas' },
    subtitle: { type: String, default: '' },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatNumberBR,
    percentWidth(value, total) {
      if (!total) return '0%';
      return `${Math.min(100, (Number(value) / Number(total)) * 100)}%`;
    },
    formatPercent(value, total) {
      if (!total) return '0%';
      const pct = (Number(value) / Number(total)) * 100;
      return `${pct.toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: pct % 1 === 0 ? 0 : 1 })}%`;
    },
  },
};
</script>

<style scoped>
.sa-dist {
  background: var(--dashboard-card, #fff);
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 14px;
  padding: 1.15rem 1.2rem 1.25rem;
  height: 100%;
  box-sizing: border-box;
}

.sa-dist__title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--dashboard-text, #191c24);
}

.sa-dist__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}

.sa-dist__head {
  margin-bottom: 1rem;
}

.sa-dist__group + .sa-dist__group {
  margin-top: 1.25rem;
  padding-top: 1.15rem;
  border-top: 1px solid var(--dashboard-border, #e8eaf0);
}

.sa-dist__group-title {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--dashboard-muted, #697386);
}

.sa-dist__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.sa-dist__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.4rem;
}

.sa-dist__label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--dashboard-text, #191c24);
}

.sa-dist__swatch {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.sa-dist__values {
  display: inline-flex;
  align-items: baseline;
  gap: 0.5rem;
  white-space: nowrap;
}

.sa-dist__values strong {
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--dashboard-text, #191c24);
}

.sa-dist__pct {
  font-size: 0.8125rem;
  color: var(--dashboard-muted, #697386);
  min-width: 3.25rem;
  text-align: right;
}

.sa-dist__track {
  height: 0.45rem;
  border-radius: 999px;
  background: #f1f2f6;
  overflow: hidden;
}

.sa-dist__fill {
  height: 100%;
  border-radius: 999px;
  transition: width 180ms ease;
}
</style>
